"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LogoText = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * The JOBMATCH.ME Logo with comany name as text
 *
 * @param {width}         size  Logo width
 * @param {height}        size  Logo height
 * @param {primary}       color Primary color
 * @param {secondary}     color Secondary color
 * @param {background}    color Background color
 *
 **/
var LogoText = function LogoText(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100' : _ref$height,
      _ref$primary = _ref.primary,
      primary = _ref$primary === void 0 ? '#004324' : _ref$primary,
      _ref$secondary = _ref.secondary,
      secondary = _ref$secondary === void 0 ? '#ffed00' : _ref$secondary,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? '#004324' : _ref$background;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "logoJMM",
    width: width,
    height: height,
    viewBox: "0 0 103.102 10.007",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-25 -28.083)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(25 28.083)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(0)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: primary,
            d: "M299.732,157.288h2.677c.066,1.063.712,1.372,1.277,1.372.619,0,1.129-.295,1.129-1.546v-5.77h2.758v5.743c0,2.879-1.3,4.048-3.914,4.048A3.657,3.657,0,0,1,299.732,157.288Z",
            transform: "translate(-299.732 -151.128)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: primary,
            d: "M307.771,156.155a5.251,5.251,0,1,1,5.246,5A4.89,4.89,0,0,1,307.771,156.155Zm7.627,0a2.385,2.385,0,1,0-2.381,2.528A2.315,2.315,0,0,0,315.4,156.155Z",
            transform: "translate(-298.756 -151.151)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: primary,
            d: "M326.806,158.041c0,1.843-1.184,2.878-3.873,2.878h-4.721v-9.576h4.627c2.071,0,3.227.781,3.227,2.246a2.071,2.071,0,0,1-1.183,2.085A2.377,2.377,0,0,1,326.806,158.041Zm-5.877-2.879h1.694c.564,0,.874-.283.874-.807a.78.78,0,0,0-.874-.847h-1.694Zm3.052,2.758c0-.5-.4-.807-1.035-.807h-2.017v1.6h2.017C323.578,158.714,323.981,158.4,323.981,157.92Z",
            transform: "translate(-297.488 -151.128)"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(30.224 0.013)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: background,
            d: "M337,151.343v9.576h-2.663v-4.048l-2.044,2.5h-.9l-2.058-2.488v4.035h-2.649v-9.576h1.412l3.752,4.573,3.725-4.573Z",
            transform: "translate(-326.683 -151.141)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: background,
            d: "M343.638,159.534h-3.525l-.619,1.385h-2.972l4.425-9.576H342.8l4.439,9.576h-2.986Zm-2.744-2.1h1.977l-.4-1.022-.579-1.8-.591,1.8Z",
            transform: "translate(-325.488 -151.141)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: background,
            d: "M347.674,153.818h-2.811v-2.475h8.393v2.475h-2.8v7.1h-2.783Z",
            transform: "translate(-324.475 -151.141)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: background,
            d: "M352.6,156.14c0-3.094,2.031-4.977,5.164-4.977a5.49,5.49,0,0,1,4.277,1.843l-2.125,1.736a2.393,2.393,0,0,0-2.044-1.077,2.5,2.5,0,0,0,0,4.989,2.35,2.35,0,0,0,2.044-1.062l2.125,1.735a5.245,5.245,0,0,1-4.277,1.829C354.634,161.156,352.6,159.246,352.6,156.14Z",
            transform: "translate(-323.536 -151.163)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: background,
            d: "M361.734,151.343h2.717v3.941h3.3v-3.941h2.716v9.576h-2.716V157.7h-3.3v3.214h-2.717Z",
            transform: "translate(-322.427 -151.141)"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: secondary,
          d: "M370.65,158.936a1.473,1.473,0,1,1,1.48,1.452A1.47,1.47,0,0,1,370.65,158.936Z",
          transform: "translate(-291.121 -150.382)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: primary,
          d: "M384.722,151.343v9.576h-2.663v-4.048l-2.043,2.5h-.9l-2.058-2.488v4.035h-2.65v-9.576h1.413l3.752,4.573,3.725-4.573Z",
          transform: "translate(-290.664 -151.128)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: primary,
          d: "M384.894,151.343h7.452v2.327h-4.829v1.466h4.062V157.3h-4.062v1.292h4.976v2.326h-7.6Z",
          transform: "translate(-289.391 -151.128)"
        })]
      })
    })
  });
};

exports.LogoText = LogoText;

var _default = /*#__PURE__*/_react.default.memo(LogoText);

exports.default = _default;